import { useTranslations } from '@npco/utils-translations'
import { Flex, Message, MessageSize, Spinner } from '@npco/zeller-design-system'

import { useIsMobileResolution } from 'hooks/useIsMobileResolution'
import { translations } from 'pages/Transfer/TransferFields/MFATransfer/MFATransfer.i18n'

export const MFASending = () => {
  const isMobile = useIsMobileResolution()
  const t = useTranslations(translations)

  const loaderSize = isMobile ? '140px' : '180px'

  return (
    <Flex width="100%" pt="10%" justifyContent="center">
      <Message
        align="center"
        title={t('mfaSendingTitle')}
        description={t('mfaSendingDescription')}
        size={MessageSize.MEDIUM}
        image={
          <Flex
            width={loaderSize}
            height={loaderSize}
            justifyContent="center"
            alignItems="center"
          >
            <Spinner />
          </Flex>
        }
      />
    </Flex>
  )
}
